/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Student_DeletingInputs */

const en_student_deleting = /** @type {(inputs: Student_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting…`)
};

const he_student_deleting = /** @type {(inputs: Student_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מוחק…`)
};

/**
* | output |
* | --- |
* | "Deleting…" |
*
* @param {Student_DeletingInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const student_deleting = /** @type {((inputs?: Student_DeletingInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Student_DeletingInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_student_deleting(inputs)
	return he_student_deleting(inputs)
});